import React, { useEffect, useState } from "react";
import "./Projects.css";
import Project from "./Project/Project";
import Modal from "../../../utilities/Modal";

const Projects = () => {
  const [id, setID] = useState(0);
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    fetch("/projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  return (
    <>
      {id !== 0 && <Modal id={id} projects={projects}></Modal>}
      <div id="projects" className="lg:mt-16 lg:mb-24 my-10 lg:mx-36">
        <h2 className="text-center lg:text-5xl text-4xl lg:mb-16 mb-2 font-[500]">
          Projects
        </h2>
        <p className="lg:hidden text-center lg:mb-0 mb-10">
          Tap to see details.
        </p>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-14 gap-y-14">
          {projects.map((project) => (
            <Project setID={setID} key={project.id} project={project} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Projects;
